// Date helpers ported from the mockup. Input dates are 'YYYY-MM-DD' strings;
// noon avoids timezone rollover when formatting.
const dateObj = (d) => new Date(`${d}T12:00:00`);
const fmt = (opts) => new Intl.DateTimeFormat('en', opts);

export const dayNum = (d) => fmt({ day: 'numeric' }).format(dateObj(d));
export const dayNumPadded = (d) => fmt({ day: '2-digit' }).format(dateObj(d));
export const monthShort = (d) => fmt({ month: 'short' }).format(dateObj(d));
export const weekdayShort = (d) => fmt({ weekday: 'short' }).format(dateObj(d));
export const year = (d) => fmt({ year: 'numeric' }).format(dateObj(d));
export const fullDate = (d) =>
    fmt({ weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }).format(dateObj(d));

export const monthKey = (d) => d.slice(0, 7);
export const monthLabel = (k) => fmt({ month: 'long', year: 'numeric' }).format(new Date(`${k}-01T12:00:00`));
export const monthLabelShort = (k) => fmt({ month: 'long' }).format(new Date(`${k}-01T12:00:00`));
